import React from "react";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
 root: { margin: "8px 0", padding: 0, listStyle: "none" },
 title: { fontSize: 10, lineHeight: "20px", fontWeight: 600, letterSpacing: "0.07em", textTransform: "uppercase", color: theme.palette.text.secondary, padding: theme.spacing(1, 2, 0.5), margin: 0 },
 divider: { height: 1, background: theme.palette.divider, margin: theme.spacing(1, 1.5) },
}));
export default function MenuSection({title,collapsed,visible=true,children}) {
 const classes=useStyles();
 if(!visible)return null;
 return <section className={classes.root} aria-label={title}>{collapsed?<div className={classes.divider}/>:<h2 className={classes.title}>{title}</h2>}{children}</section>;
}
